import { useTranslation } from 'react-i18next'
import { SUPPORTED_LOCALES, type SupportedLocale } from '../lib/constants'

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation()
  const current = (SUPPORTED_LOCALES.includes(i18n.resolvedLanguage as SupportedLocale)
    ? i18n.resolvedLanguage
    : 'en') as SupportedLocale

  return (
    <label className="field" style={{ margin: 0 }}>
      <span className="visually-hidden">{t('lang.label')}</span>
      <select
        className="lang-select"
        aria-label={t('lang.label')}
        value={current}
        onChange={(e) => void i18n.changeLanguage(e.target.value)}
      >
        {SUPPORTED_LOCALES.map((lng) => (
          <option key={lng} value={lng}>
            {t(`lang.${lng}`)}
          </option>
        ))}
      </select>
    </label>
  )
}
